import { DateTime } from "luxon";

export const parseDateToUTC = (dateString: string) => {
  const dateParts = dateString.split(" ");
  const date = new Date(
    Date.UTC(
      parseInt(dateParts[0].split("-")[0]), // Year
      parseInt(dateParts[0].split("-")[1]) - 1, // Month (0-based)
      parseInt(dateParts[0].split("-")[2]), // Day
      parseInt(dateParts[1]?.split(":")[0]), // Hour
      parseInt(dateParts[1]?.split(":")[1]), // Minute
      parseInt(dateParts[1]?.split(":")[2]) // Second
    )
  );
  return date;
};

export const convertToDate = (dateInput: string) => DateTime.fromISO(dateInput).startOf("day");
